import axios from 'axios';

const BASE_URL = 'https://tetfundTagapi.lloydant.com/api';
export const FILE_BASE_URL = 'https://tetfundTagapi.lloydant.com';

export interface ApiResponse<T = any> {
  isSuccess: boolean;
  message: string;
  data: T;
  errors?: any;
}

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');

    if (token && !config.skipAuth) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear all auth data
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('token');

      // Redirect to login
      window.location.href = '/login';
      return Promise.reject(error);
    }


    // This handles cases where the API returns e.g. 400 but isSuccess is true.
    if (error.response && error.response.data?.isSuccess === true) {
      return Promise.resolve(error.response);
    }

    return Promise.reject(error);
  }
);

